import { ChangeDetectionStrategy, Component, input, output } from "@angular/core";

/**
 * Used for keyboard users to quickly skip to specific content. It can also function as a skip button - for this, use the onClick event
 */
@Component({
  selector: "bi-skip-link",
  template: ` <a class="skipper" tabIndex="0" href="#{{ skipToId() }}" (keydown.enter)="onLinkClicked($event)" (click)="onLinkClicked($event)">{{ label() }}</a> `,
  styleUrl: "./bi-skip-link.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BiSkipLinkComponent {
  readonly skipToId = input<string>();
  readonly label = input.required<string>();

  onClick = output<Event>();

  public onLinkClicked(event: Event) {
    event.preventDefault();
    document.getElementById(this.skipToId())?.focus();
    this.onClick.emit(event);
  }
}
